import { useMedia } from 'react-use';

const DEFAULT_BREAKPOINT = 768;

function useIsMobile(breakPoint: number = DEFAULT_BREAKPOINT) {
  const query = `(max-width: ${breakPoint - 1}px)`;
  const defaultState = window.innerWidth < breakPoint;

  return useMedia(query, defaultState);
}

export default useIsMobile;
